import { cacheUnaryFunction } from "../../Algebra/Core/index.mjs";
import { makeSummoner } from "../usage/summoner/index.mjs";
export const opaque = () => x => x;
export const opaque_ = () => x => x;
export const summonFor = _env => makeSummoner(cacheUnaryFunction, () => {
  return {
    build: a => a
  };
});
//# sourceMappingURL=index.mjs.map